export default __webpack_public_path__ + "assets/072d78391a507de17c1bc8df575e2051.webp";